<template>
  <div class="container">
    <header>
      <!-- <h4>交易数字见证系统</h4> -->
     <img :src="logoTitle" alt="">
    </header>
    <section>
      <div class="center">
        <div class="centerRight" id="loginBox">
          <router-view></router-view>
        </div>
      </div>
    </section>
    <!-- <footer>
      <p>分辨率1440*900以上 | 浏览器IE11及以上版本 </p>
      <p>技术支持 ：品茗科技股份有限公司</p>
    </footer> -->
  </div>
</template>
<script>
  export default {
    data() {
      return {
        logoTitle:require('@/assets/img/login/loginTitle.png'),
      };
    },
    methods: {},
    mounted: function () {

    }
  };
</script>
<style lang="less">
  html, body {
    height: 100%
  }

  ul, li {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .container {
    width: 100%;
    height: 100%;
    min-width: 1280px;
    min-height: 648px;
    background-image: url(../../assets/img/login/loginBg.png);
    background-size: 100% 100%;

    header {
      width: 100%;
    //   height: 86px;
    //   text-align: left;
    //   padding-left: 20%;
    //   font-size: 28px;
    //   vertical-align: middle;
      color: #FFFFFF;
      h4{
        color: #000;
        line-height: 86px;
        margin: 0;
        font-weight: 500;
      }
      img{
        margin-top: 40px;
        margin-left: 40px;
        width: 579px;
        height:66px;
      }
    }

    header p {
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #072130;
      margin-left: 50px;
    }

    section {
      flex: 1;
      display: flex;
      align-items: center;
      position: relative;
      flex-direction: column;
    //   background: url(../../assets/img/login/bj.png) no-repeat 100%;
    //   background-size: 100%;
      width: 100%;
      height: calc(100% - 200px);
    }

    .center {
      width: 502px;
      height: 440px;
      position: absolute;
      top: calc(50% - 191px);
      right: 230px;;
      display: flex;
      background-color: #FFFFFF;
     //   box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.3);
      box-shadow: 0 0 20px 0 #0574db1a;
      border-radius: 3px;
    }

    .centerRight {
      display: flex;
      flex-direction: column;
      padding: 40px 40px 26px 40px;
      width: 100%;
      height: 100%;
    }

    .centerRight p {
      cursor: pointer;
      width: 100%;
      display: inline-block;
      text-align: center;
      font-size: 24px;
      line-height: 28px;
      margin: 0;
      padding: 20px 0;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #3A3A3A;
      text-indent: 10px;
    }

    .centerRight p span {
      padding: 20px 0;
    }

    .centerRight p span.active {
      color: #1965FF;
      border-bottom: 3px solid #1965FF;
    }
    .el-form {
      margin-top: 40px;
    }

    .centerRight /deep/ .login-form .el-form-item__label {
      color: #333333;
      font-size: 20px;
      padding-left: 10px;
    }

    .centerRight /deep/ .login-form .el-form-item__label:before {
      display: none;
    }
    .centerRight .blue-back {
      font-size: 16px;
      color: #666666;
      padding-left: 10px;
    }

    .login-li {
      position: relative;
    }

    .login-li > i {
      width: 21px;
      height: 24px;
      position: absolute;
      left: 5px;
      bottom: 7px;
      z-index: 1;
      background-size: auto 80%;
    }

    .login-user {
      background: url("../../assets/images/icon-user.png") no-repeat 50% 50%;
    }

    .login-pwd {
      background: url("../../assets/images/icon-pwd.png") no-repeat 50% 50%;
    }

    .forget .el-form-item__content,
    .forget .el-form-item__error {
      padding-left: 105px;
    }

    .btn-li .el-form-item__content {
      padding: 0;
    }

    .forget .el-form-item__label {
      width: 95px;
      padding: 0;
      margin: 0;
      text-align: right;
    }

    .forget /deep/ .message-btn {
      display: block;
      width: 120px;
      height: 36px;
      background: #3059FE;
      color: #fff;
      text-align: center;
      border-radius: 5px;
      cursor: pointer;
    }

    footer {
      width: 100%;
      height: 114px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    footer p {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 2px;
      color: #333333;
    }
  }

  .lock-box {
    width: 100%;
    // margin: 30px 0 20px 0;
    // height: 264px;

    .lock {
      background: url("../../assets/images/lock.png") no-repeat;
      background-size: 100% 100%;
      width: 136px;
      height: 136px;
      margin: 0 auto;
    }

    p.sizi {
      width: 360px;
      margin-top:32px;
      text-align: center;
      padding: 0;
      font-size: 18px;
    }

    button {
      width: 100%;
      height: 50px;
      border-radius: 5px;
      border: 0;
      outline: 0;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      margin-top: 20px;
    }
  }
</style>
